module.exports = __webpack_public_path__ + "img/demigods_1248.ecc07d9a.png";